import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Frase from './components/Frase';
import {useState, useEffect} from 'react';
import Spinner from './components/Spinner';

function App() {
  // Creo state de objeto
  const [personaje, setPersonaje] = useState({});
  const [cargando, setCargando] = useState(false);

  useEffect(()=>{
    consultarApi(); 
  },[]);

  const consultarApi = async()=>{
    setCargando(true);
    const respuesta = await fetch('https://thesimpsonsquoteapi.glitch.me/quotes');
    const resultado = await respuesta.json();
    console.log(respuesta);
    console.log(resultado[0]);

    setTimeout(()=>{
      // Guardo objeto dentro de state
      setPersonaje(resultado[0]);
      setCargando(false);
    },2500);
  }

  // Operador ternario (condicion) ? (lo que quiero hacer si la condicion es true) : (lo que quiero hacer si la condicion es false)
  const mostrarComponente =  (cargando === true) ? (<Spinner></Spinner>) : (<Frase personaje={personaje}></Frase>);

  return (
    <section className="container text-center my-5">
      <article className="d-flex flex-column align-items-center">
        <img 
        src={process.env.PUBLIC_URL+'logo.png'} 
        alt="logo de los simpsons" 
        className="logoSize"
        />
        <button className="my-5 btn-lg amarillo" onClick={()=>consultarApi()}>Generar Frase</button>
      </article>
      {
        mostrarComponente
      }
    </section>
  );
}

export default App;
